import {
  UPDATE_USER_DETAILS,
  REFRESH_REDUCERS,
  UserDetailsActions,
  UserDetails
} from '../action';

const initialState: UserDetails = {
  firstName: '',
  lastName: '',
  stateCode: '',
  zip: ''
};

export default function(state= initialState, action: UserDetailsActions): UserDetails {
  switch(action.type){
    case UPDATE_USER_DETAILS:
      return {...state, ...action.payload }
    case REFRESH_REDUCERS:
      return { ...initialState };
    default:
      return state;
  }
}
